/** @format */
import React from 'react';
import NumberFormat from 'react-number-format';
import {ORDER_STATUS_IN_CART, PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';
import withEditCartHandler from './with_edit_cart_handler';
import Order from './order';
import GraphicDesignOrder from './graphic_design_order';
import {Loading, ConditionalButton} from 'frontier-utilities';
import {Button} from '@sttark/design-system';

// stlyes
import './container.sass';
import {CartOverviewSummary, CTAS, GetHelp} from './cart_overview_summary';

export default withEditCartHandler(props => {
    const {cart} = props;
    const ordersInCart = props.orders.filter(({status_id}) => status_id === ORDER_STATUS_IN_CART);

    if (!props.loading && props.error) {
        // TODO - Error handling should be better implemented after the cart rewrite
        return <div className="alert alert-danger">{props.error.message}</div>;
    }

    if (ordersInCart.length === 0 && !props.loading) {
        return (
            <div className="nothin-in-cart-contianer">
                <h3 className="nothin-in-cart-contianer_title text-center">
                    There’s nothing in your cart... yet.
                </h3>
                <p className="nothin-in-cart-contianer_desc text-center">
                    To get started creating your next printed product:
                </p>
                <div className="nothin-in-cart-contianer_button d-flex align-items-center justify-content-center">
                    <Button
                        label="Get an Instant Quote"
                        url="/orders/quoter"
                        iconRight="navigateRight"
                        primary
                        large
                    />
                </div>
                <h3 className="nothin-in-cart-contianer_title text-center">Or</h3>
                <p className="nothin-in-cart-contianer_desc text-center">
                    Give our Customer Care team a call at (877) 277-4682
                </p>

                {typeof cart.user_id === 'undefined' && (
                    <div style={{marginTop: '50px'}}>
                        <div style={{fontSize: '16px'}}>Do you have an account?</div>
                        <div style={{fontSize: '20px'}}>
                            <a href="/account/users/login?redirect=/cart">Log-in</a> to get your
                            last created cart.
                        </div>
                    </div>
                )}
            </div>
        );
    }

    if (props.loading) {
        return (
            <div className="bs4 bs4-utils bs4-grid ">
                <Loading
                    message="Gathering Order Information..."
                    messageSize="22px"
                    height="50vh"
                />
            </div>
        );
    }

    return (
        <div className="cart-main-container d-flex align-items-start justify-content-center">
            {/* only displays on mobile*/}
            <div className="cart-summary-footer--mobile w-100 mt-5">
                {/* ctas */}
                <CTAS />

                {/*    get help */}
                <GetHelp />
            </div>
            <div className="cart-items-container">
                <div className="bs4 bs4-utils bs4-grid bs4-modal bs4-form bs4-buttons bs4-badge">
                    <div>
                        {props.combinedCount > 0 && (
                            <div
                                className="alert alert-info"
                                style={{background: '#00892F', color: '#000000', fontSize: '22px'}}>
                                Orders with matching specs have been combined for a cost savings!
                            </div>
                        )}
                        <div>
                            <div className="cart-order-header bg-structure-lightest">
                                <h3 className="font-body-bold-xl">Item</h3>
                                <h3 className="font-body-bold-xl">Qty</h3>
                                <h3 className="font-body-bold-xl">Unit</h3>
                                <h3 className="font-body-bold-xl">Subtotal</h3>
                            </div>
                            {ordersInCart.map((order, index) => (
                                <ConditionalButton
                                    key={index}
                                    enabled={order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN}>
                                    <GraphicDesignOrder
                                        {...order}
                                        orderStatus={order.status}
                                        index={index}
                                        fieldsSaving={props.fieldsSaving}
                                        onSavedToAccount={props.onSavedToAccount}
                                        onDelete={props.onDeleteOrder.bind(this, order.id)}
                                        substrates={props.substrates}
                                        key={order.id + 'order'}
                                        totalOrderCount={cart.order_count}
                                    />
                                    <Order
                                        {...order}
                                        saveFileEndpoint={
                                            '/account/designs/add/' + order.id + '/1000'
                                        }
                                        onDeleteDesign={props.onDeleteDesign}
                                        onAllUploadsComplete={props.onAllUploadsComplete.bind(
                                            this,
                                            order.id
                                        )}
                                        orderStatus={order.status}
                                        index={index}
                                        fieldsSaving={props.fieldsSaving}
                                        onDelete={props.onDeleteOrder.bind(this, order.id)}
                                        onChange={props.onChange}
                                        onChangeOrder={props.onChangeOrder}
                                        onSavedToAccount={props.onSavedToAccount}
                                        substrates={props.substrates}
                                        key={order.id + 'order'}
                                        totalOrderCount={cart.order_count}
                                    />
                                </ConditionalButton>
                            ))}
                        </div>
                        <div className="text-right" style={{marginRight: '33px'}}>
                            <small>
                                <em>cid: {cart.id}</em>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-summary">
                <CartOverviewSummary cart={{orders: ordersInCart, subtotal: cart.subtotal}} />
            </div>
        </div>
    );
});
